import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class NumberRangeValidator {
  static checkValues: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const fromControl = control.value?.from;
    const toControl = control.value?.to;

    if (fromControl && toControl && parseFloat(fromControl) > parseFloat(toControl)) {
      return { valueFromGraterThenTo: true };
    }

    return null;
  };
}